import { UserInfo } from "../types";
import { OptionIndicator } from "@quark/shared-types";
import { LOGIN_EVENT } from "../constants";

export const alphabetToNumber = (alphabet: OptionIndicator | undefined) => {
  return "ABCDEFGHIJK".split("").findIndex((a) => a === alphabet) + 1;
};

export const numberToAlphabet = (number: number) => {
  return "ABCDEFGHIJK".split("")[number - 1];
};

export const updateSdkSetting = (userInfo: UserInfo) => {
  const win = window as any;
  const { hostname } = win.location;
  win?.clarity("identify", userInfo.user_id);
  win?.clarity("set", "nickname", userInfo.nickname);
  win?.clarity("set", "hostname", hostname);
};

export const login = () => {
  window.dispatchEvent(new Event(LOGIN_EVENT));
  // window.location.href = `//edu.py2fun.com/login?redirect_url=${encodeURIComponent(
  //   window.location.href
  // )}`;
};

export const logout = () => {
  window.location.href = `https://api.py2fun.com/api/pytip/logout?next=${encodeURIComponent(
    `${window.location.origin}/home`
  )}`;
};

export const isEmpty = (value: any) => {
  if (typeof value === "undefined") {
    return true;
  }
  if (value === null) {
    return true;
  }
  if (typeof value === "string") {
    if (value.trim() === "") {
      return true;
    }
  }
  if (Object.prototype.toString.call(value) === "[object Array]") {
    if (value.length === 0) {
      return true;
    }
  }
  if (Object.prototype.toString.call(value) === "[object Object]") {
    if (JSON.stringify(value) === "{}") {
      return true;
    }
  }
  return false;
};

// 人民币格式化，new Intl.NumberFormat("zh-CN", { style: "currency", currency: "CNY" }).format(1000)
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat("zh-CN", {
    style: "currency",
    currency: "CNY",
  }).format(amount);
};
